import React from 'react'
import { createRoot } from 'react-dom/client'
import MakoApp from '@app/MkApp'

import '@styles/app.scss'
import '@utils/patchXhrForDynatrace'

createRoot(document.getElementById('root') as HTMLElement).render(
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'stage' ? (
    <MakoApp />
  ) : (
    <React.StrictMode>
      <MakoApp />
    </React.StrictMode>
  ),
)
